import { render } from "./MenuLateral.vue?vue&type=template&id=063b4490&scoped=true&ts=true"
import script from "./MenuLateral.vue?vue&type=script&lang=ts"
export * from "./MenuLateral.vue?vue&type=script&lang=ts"

import "./MenuLateral.vue?vue&type=style&index=0&id=063b4490&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063b4490"]])

export default __exports__